import { render, staticRenderFns } from "./ModalLogin.vue?vue&type=template&id=00b47b08&scoped=true"
import script from "./ModalLogin.vue?vue&type=script&lang=js"
export * from "./ModalLogin.vue?vue&type=script&lang=js"
import style0 from "./ModalLogin.vue?vue&type=style&index=0&id=00b47b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b47b08",
  null
  
)

export default component.exports